import { Navigate } from "react-router-dom";
import routes from "../routes";
import sectionsService from "./sections-service";

function hasRouteException(userId, routeKey, exceptionRoutes = {}) {
  const allowedRoutes = exceptionRoutes?.[userId] || [];

  return allowedRoutes.includes(routeKey);
}

function canAccessRoute(isAdmin, userId, route, exceptionRoutes = {}) {
  if (!route.adminOnly) return true;

  return isAdmin || hasRouteException(userId, route.key, exceptionRoutes);
}

async function filteredRoutes(
  label,
  cancelToken,
  logout,
  isAdmin,
  exceptionRoutes = {},
  userId = null,
  permissions = [],
) {
  const [response, data] = await sectionsService.getSections(null, cancelToken);
  const filtered = [];
  const visibleRoutes = routes(label).filter(route => route.key !== "ncr" || permissions.some(permission => ["get-ncr", "getMy-ncr", "create-ncr", "update-ncr"].includes(permission.name)));
  const baseRoutes = visibleRoutes.filter((route) => {
    if (route.type === "group") {
      return (
        canAccessRoute(isAdmin, userId, route, exceptionRoutes) ||
        route.components?.some((componentRoute) =>
          canAccessRoute(isAdmin, userId, componentRoute, exceptionRoutes),
        )
      );
    }

    return canAccessRoute(isAdmin, userId, route, exceptionRoutes);
  });

  if (!response?.ok) {
    return baseRoutes;
  }

  let allRoutes = baseRoutes
    .map((route) => {
      if (route.type === "group") {
        const acceptable = [];
        route.components.map((componentRoute) => {
          const section = data.find((section) => section.key == componentRoute.key);
          if (
            section &&
            canAccessRoute(isAdmin, userId, componentRoute, exceptionRoutes)
          ) {
            acceptable.push({ ...componentRoute, section });
          }
        });

        if (acceptable.length) {
          filtered.push({ ...route, components: acceptable });
        }
      } else {
        const section = data.find((section) => section.key == route.key);
        if (section) {
          filtered.push({ ...route, section });
        }
      }

      return route;
    })
    .filter((v) => data.find((d) => d.key == v.key));

  if (!data?.length) logout();

  const dashboardRoute = filtered.find((route) => route.key === "dashboard");
  if (!dashboardRoute)
    filtered.push({
      type: "hidden",
      name: "Dashboard",
      key: "dashboard",
      route: "/dashboard",
      component: <Navigate to={allRoutes[0]?.route || "/audits"} />,
    });

  return filtered;
}

export default filteredRoutes;
